import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Input, Form,FormFeedback} from 'reactstrap';
import Select from 'react-select';
import { resourcesConditions } from '../../../helpers/backend_helper';
import { getStorageUser } from '../../../helpers/api_helper';
import {Alert,ToastHelper} from '../../../helpers/alerts/alertHelper';
import * as Yup from "yup";
import { useFormik } from "formik";


const AddUpdModal = ({modal,setModal,items, setItems, setItem,item}) => {
	const [ errors, setErrors ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const authUser = getStorageUser();
	const handleClose = () => {
		setModal({...modal,show:false,update:false});
    }

    const validation = useFormik({
		enableReinitialize: true,
		initialValues: item,
		validationSchema: Yup.object({
			name: Yup.string().required('Required').min(1),
			order: Yup.number().required('Required').typeError("Must be a number"),
		}),
		onSubmit: async values => {
			await save(values)
			
		},
	});

    const save = (data) => {
    	setErrors([])
    	setLoading(true)
    	resourcesConditions(modal.update ? 'put':'post',data,modal.update ? data.id:'').then(response => {
    			responseAction(response);			
    		})
    }

    const responseAction = (response) => {
    	if(response.status){
    		const newItem = response.condition;
    		let array = [];
    		if(modal.update){
    			array = items.map(item => item.id !== newItem.id ? item : newItem);
    		}else{
    			array = [...items, newItem];
    			array.sort((a, b) => {
    				return a.id - b.id;
    			});
    		}
    		
			validation.resetForm();
    		setItems(array);
			handleClose()
			setLoading(false)
    	}else{
    		setLoading(false)
    		setErrors(response.response.data.errors)
    	}
    }


    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-warning">{modal.update ? 'Editar ':'Agregar '}Emresa</ModalHeader>
				<Form
					onSubmit={e => {
					e.preventDefault();
					validation.handleSubmit();
					return false;
					}}
				>
				<ModalBody>
				<div className="row">
					<div className="col-sm-6">
						<label className="form-label">Nombre:</label>
					    <Input
							name="name"
							type="text"
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.name || ""}
							invalid={
								validation.touched.name &&
								validation.errors.name
								? true
								: false
							}
						/>
					    {(validation.touched.name && validation.errors.name) && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
					</div>
					<div className="col-sm-6">
						<label className="form-label">Orden:</label>
					    <Input
							name="order"
							type="text"
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.order || ""}
							invalid={
								validation.touched.order &&
								validation.errors.order
								? true
								: false
							}
						/>
					    {(validation.touched.order && validation.errors.order) && <FormFeedback type="invalid">{validation.errors.order}</FormFeedback>}
					</div>
				</div>	
				</ModalBody>
				<ModalFooter>
					<Button color="primary" type="submit" disabled={loading}>
						{loading && <Spinner size="sm"></Spinner> } <i className='fa fa-save'></i> Guardar
					</Button>{' '}
					<Button color="secondary" onClick={handleClose}> <i className='fa fa-times'></i> Cancelar</Button>
				</ModalFooter>
				</Form>
	        </Modal>
		</div>
	);
}

export default AddUpdModal;